'use client';

import { styled } from '@mui/material';

export const TableMobileLoadingContainer = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  gap: theme.spacing(2),
}));

export const TableMobileLoadingItemContainer = styled('div')(({ theme }) => ({
  width: '100%',
  height: 80,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(4),
  borderRadius: theme.spacing(4),
  background: theme.palette.surface2,
}));

export const TableMobileLoadingItemContent = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: theme.spacing(3),
}));

export const TableMobileLoadingItemNameContainer = styled('div')(
  ({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  }),
);
